export default "__VITE_ASSET__38c8e3c7__"